module.exports = __webpack_public_path__ + "static/media/beachsoccer.b2bc2393.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/beachsoccer.svg
// module id = 362
// module chunks = 7